import React from "react";
import { useSelector } from "react-redux";
import TextInput from "../../../components/TextInput";
import Dropdown from "components/Dropdown";
import PasswordInput from "../../../components/PasswordInput";
import { WORKING_AGE } from '../../../constants/index';
import { getItemsDay, getItemsMonth, getItemsYear } from "../../../utils/util";
import CustomTag from "../../../components/CustomTag";

const BaseFormSection = ({formData, setFormData, errors, onChange, onBlur, options, setters, getValueByObject}) => {
    const { companyInfo, type, isLoadingRegister, talentOptionsRelatedRegister } = useSelector((state: any) => state.talentRegister);

    const dataYearOfBirth = getItemsYear(new Date().getFullYear() - WORKING_AGE, 100 - WORKING_AGE);
    const dataMonth = getItemsMonth();

    const changeYearOfBirth = (value: any, name: any) => {
        let dateOfBirth = formData.dateOfBirth
    
        if(value && getValueByObject(value)
            && formData.monthOfBirth && getValueByObject(formData.monthOfBirth)) {
            const dataDate = getItemsDay(
                getValueByObject(value),
                getValueByObject(formData.monthOfBirth),
            );
            setters.setDayOptions(dataDate);
        
            if(dateOfBirth && !dataDate.some(item => item.id === dateOfBirth.id)) {
                dateOfBirth = null
            }
        }
    
        setFormData((prev) => ({
            ...prev,
            [name]: value,
            dateOfBirth: dateOfBirth
        }));
    };

    const changeMonthOfBirth = (value: any, name: any) => {
        let dateOfBirth = formData.dateOfBirth
    
        if(formData.yearOfBirth && getValueByObject(formData.yearOfBirth) && value && getValueByObject(value)) {
            const dataDate = getItemsDay(
                getValueByObject(formData.yearOfBirth),
                getValueByObject(value),
            );
            setters.setDayOptions(dataDate);
        
            if(dateOfBirth && !dataDate.some(item => item.id === dateOfBirth.id)) {
                dateOfBirth = null
            }
        }
    
        setFormData((prev) => ({
            ...prev,
            [name]: value,
            dateOfBirth: dateOfBirth
        }));
    };

    return (
        <>
        <div className="mb-4">
            <label className="block mb-2 text-sm alu-text-base-2" htmlFor="company">
                登録先企業
            </label>
            <TextInput
                error={errors.company}
                errorText={errors.company}
                size="lg"
                type="text"
                id="company"
                name="company"
                defaultValue={companyInfo?.name}
                placeholder="入力してください"
                disabled
                customClassName="!h-[2.8125rem]"
            />
        </div>
        <div className="mb-4">
            <div className="flex items-center gap-2 mb-2">
                <label className="block text-sm leading-none alu-text-base-2" htmlFor="fullName">氏名</label>
                <CustomTag type="required" />
            </div>
            <div className="flex items-top gap-2">
                <div className="w-[9rem]">
                <TextInput
                    error={errors.last_name}
                    errorText={errors.last_name}
                    id="last_name"
                    name="last_name"
                    value={formData.last_name}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder="姓"
                    customClassName="!h-[2.8125rem]"
                    maxLength={100}
                    tabindex={1}
                />
                </div>
                <div className="w-[9rem] md:w-[12.25rem]">
                <TextInput
                    error={errors.first_name}
                    errorText={errors.first_name}
                    id="first_name"
                    name="first_name"
                    value={formData.first_name}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder="名"
                    customClassName="!h-[2.8125rem]"
                    maxLength={100}
                    tabindex={2}
                />
                </div>
            </div>
        </div>
        <div className="mb-4">
            <div className="flex items-center gap-2 mb-2">
                <label className="block text-sm leading-none alu-text-base-2" htmlFor="fullName">氏名（カナ）</label>
                <CustomTag type="required" />
            </div>
            <div className="flex items-top gap-2">
                <div className="w-[9rem]">
                <TextInput
                    error={errors.last_name_kana}
                    errorText={errors.last_name_kana}
                    id="last_name_kana"
                    name="last_name_kana"
                    value={formData.last_name_kana}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder="セイ"
                    customClassName="!h-[2.8125rem]"
                    maxLength={100}
                    tabindex={3}
                />
                </div>
                <div className="w-[9rem] md:w-[12.25rem]">
                <TextInput
                    error={errors.first_name_kana}
                    errorText={errors.first_name_kana}
                    id="first_name_kana"
                    name="first_name_kana"
                    value={formData.first_name_kana}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder="メイ"
                    customClassName="!h-[2.8125rem]"
                    maxLength={100}
                    tabindex={4}
                />
                </div>
            </div>
        </div>
        <div className="mb-4">
            <div className="flex items-center gap-2 mb-2">
                <label className="block text-sm leading-none alu-text-base-2 pointer-events-none" htmlFor="gender">性別</label>
                <CustomTag type="required" />
            </div>
            <div className="w-[12.25rem]">
            <Dropdown
                error={errors.gender}
                errorText={errors.gender}
                disabled={isLoadingRegister}
                inputWidth="full"
                placeholder={"選択してください"} 
                options={talentOptionsRelatedRegister?.gender_options || []} 
                value={formData.gender}
                onChange={(value: any) => {
                    setFormData((prev: any) => ({...prev, gender: value}))
                }}
                tabindex={5}
            />
            </div>
        </div>
        <div className="mb-4 md:w-[346px]">
            <div className="flex items-center gap-2 mb-2">
                <label className="block text-sm leading-none alu-text-base-2 pointer-events-none" htmlFor="email">メールアドレス</label>
                <CustomTag type="required" />
            </div>
            <TextInput
                error={errors.email}
                errorText={errors.email}
                id="email"
                name="email"
                value={formData.email}
                onChange={onChange}
                onBlur={onBlur}
                placeholder="sample@sample.com"
                customClassName="!h-[2.8125rem]"
                maxLength={255}
                tabindex={6}
            />
        </div>
        <div className="mb-4 md:w-[346px]">
            <div className="flex items-center gap-2 mb-2">
                <label className="block text-sm leading-none alu-text-base-2 pointer-events-none" htmlFor="email2">メールアドレス（確認）</label>
                <CustomTag type="required" />
            </div>
            <TextInput
                error={errors.email2}
                errorText={errors.email2}
                id="email2"
                name="email2"
                value={formData.email2}
                onChange={onChange}
                onBlur={onBlur}
                placeholder="sample@sample.com"
                customClassName="!h-[2.8125rem]"
                maxLength={255}
                tabindex={7}
            />
        </div>
        <div className="mb-4 md:w-[346px]">
            <div className="flex items-center gap-2 mb-2">
                <label className="block text-sm leading-none alu-text-base-2 pointer-events-none" htmlFor="password">パスワードを設定</label>
                <CustomTag type="required" />
            </div>
            <div className='relative'>
                <PasswordInput
                    error={errors.password.length > 0}
                    errorText={errors.password}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={onChange}
                    placeholder="8文字以上で英数字を含めてください"
                    maxLength={255}
                    tabindex={8}
                />
            </div>
        </div>
        <div className="mb-4 md:w-[346px]">
            <div className="flex items-center gap-2 mb-2">
                <label className="block text-sm leading-none alu-text-base-2 pointer-events-none" htmlFor="password2">パスワードを設定（確認）</label>
                <CustomTag type="required" />
            </div>
            <div className='relative'>
                <PasswordInput
                    error={errors.password2.length > 0}
                    errorText={errors.password2}
                    id="password2"
                    name="password2"
                    value={formData.password2}
                    onChange={onChange}
                    placeholder="8文字以上で英数字を含めてください"
                    maxLength={255}
                    tabindex={9}
                />
            </div>
        </div>
        <div className="mb-4 md:w-1/2">
            <div className="flex items-center gap-2 mb-2">
                <label className="block text-sm leading-none alu-text-base-2 pointer-events-none" htmlFor="dateOfBirth">生年月日</label>
                <CustomTag type="required" />
            </div>
            <div className="flex items-top gap-2 md:gap-4 md:w-[346px]">
                <div className="w-1/3 md:w-[115px] md:shrink-0">
                    <Dropdown
                        disabled={isLoadingRegister}
                        inputWidth="full"
                        error={errors.yearOfBirth}
                        errorText={errors.yearOfBirth}
                        placeholder={"西暦"}
                        options={dataYearOfBirth}
                        value={formData.yearOfBirth}
                        unitLabel="年"
                        onChange={(value: any) => changeYearOfBirth(value, "yearOfBirth")}
                        tabindex={10}
                    />
                </div>
                <div className="w-1/3 md:w-1/3">
                    <Dropdown
                        disabled={isLoadingRegister}
                        inputWidth="full"
                        error={errors.monthOfBirth}
                        errorText={errors.monthOfBirth}
                        placeholder={"月"}
                        options={dataMonth}
                        value={formData.monthOfBirth}
                        unitLabel="月"
                        onChange={(value: any) => changeMonthOfBirth(value, "monthOfBirth")}
                        tabindex={11}
                    />
                </div>
                <div className="w-1/3 md:w-1/3">
                    <Dropdown
                        disabled={isLoadingRegister}
                        inputWidth="full"
                        error={errors.dateOfBirth}
                        errorText={errors.dateOfBirth}
                        placeholder={"日"}
                        options={options.dayOptions}
                        value={formData.dateOfBirth}
                        unitLabel="日"
                        onChange={(value: any) => setFormData((prev) => ({ ...prev, dateOfBirth: value })) }
                        tabindex={12}
                    />
                </div>
            </div>
        </div>
        </>
    );
};

export default BaseFormSection;